import MenuCategoriasProduto from './categorias/store'

export default {
    MenuCategoriasProduto
}